import { Currency } from '@/utils/currency'
import { Region } from '@/utils/region'
import useLocale from '@/utils/useLocale'

export interface OptionProp {
  lang: string
  label: string
  sign: string
  region: Region
  name: string
  value: Currency
  nameSlug: string
  isInternalTesting: boolean
}

const useRegionOptions = () => {
  const t = useLocale()
  const globalOption: OptionProp = {
    lang: '',
    label: '',
    sign: '',
    region: Region.GLOBAL,
    name: t['region.ALL'],
    value: Currency.GLOBAL,
    nameSlug: 'global',
    isInternalTesting: false
  }
  const usOption: OptionProp = {
    lang: t['USDL'],
    label: t['USD'],
    sign: '$',
    region: Region.US,
    name: t['region.US'],
    value: Currency.US,
    nameSlug: 'united-states',
    isInternalTesting: false
  }
  const regionOptions: OptionProp[] = [globalOption, usOption].concat(
    [
      {
        lang: t['VNDL'],
        label: t['VND'],
        sign: '₫',
        region: Region.VN,
        name: t['region.VN'],
        value: Currency.VN,
        nameSlug: 'vietnam'
      },
      {
        lang: t['THBL'],
        label: t['THB'],
        sign: '฿',
        region: Region.TH,
        name: t['region.TH'],
        value: Currency.TH,
        nameSlug: 'thailand'
      },
      {
        lang: t['PHPL'],
        label: t['PHP'],
        sign: '₱',
        region: Region.PH,
        name: t['region.PH'],
        value: Currency.PH,
        nameSlug: 'philippines'
      },
      {
        lang: t['MYRL'],
        label: t['MYR'],
        sign: 'RM',
        region: Region.MY,
        name: t['region.MY'],
        value: Currency.MY,
        nameSlug: 'malaysia'
      },
      {
        lang: t['IDRL'],
        label: t['IDR'],
        sign: 'Rp',
        region: Region.ID,
        name: t['region.ID'],
        value: Currency.ID,
        nameSlug: 'indonesia'
      },
      {
        lang: t['GBPL'],
        label: t['GBP'],
        sign: '£',
        region: Region.GB,
        name: t['region.GB'],
        value: Currency.GB,
        nameSlug: 'uk'
        // isInternalTesting: true
      },
      {
        lang: t['SGDL'],
        label: t['SGD'],
        sign: 'S$',
        region: Region.SG,
        name: t['region.SG'],
        value: Currency.SG,
        nameSlug: 'singapore'
        // isInternalTesting: true
      },
      {
        lang: t['ESDL'],
        label: t['EUR'],
        sign: '€',
        region: Region.ES,
        name: t['region.ES'],
        value: Currency.ES,
        nameSlug: 'spain'
      },
      {
        lang: t['ESDL'],
        label: t['MXN'],
        sign: 'MX',
        region: Region.MX,
        name: t['region.MX'],
        value: Currency.MX,
        nameSlug: 'mexico'
      },
      {
        lang: t['USDL'],
        label: t['EUR'],
        sign: '€',
        region: Region.DE,
        name: t['region.DE'],
        value: Currency.DE,
        nameSlug: 'germany',
        isInternalTesting: true
      },
      {
        lang: t['USDL'],
        label: t['EUR'],
        sign: '€',
        region: Region.IT,
        name: t['region.IT'],
        value: Currency.IT,
        nameSlug: 'italy',
        isInternalTesting: true
      },
      {
        lang: t['USDL'],
        label: t['EUR'],
        sign: '€',
        region: Region.FR,
        name: t['region.FR'],
        value: Currency.FR,
        nameSlug: 'france',
        isInternalTesting: true
      }
    ].map((item) => ({ ...item, isInternalTesting: item.isInternalTesting || false }))
  )

  return {
    usOption,
    regionOptions
  }
}

export default useRegionOptions
